module.exports = __webpack_public_path__ + "static/media/Logout.a12b0ece.svg";